module.exports = __webpack_public_path__ + "static/media/icon-nosso.abdcc0e6.svg";